import { BaseService } from './base.service';

export class OwnerServiceUsagesService extends BaseService {
  static get resourceEndpoint() {
    return 'owner_service_usages';
  }
}